import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  HStack,
} from '@chakra-ui/react'
import { useQuery } from 'react-query'

import { Dialog, DialogTrigger } from '@/components/shared/bundles/Drawer'
import { Buttons } from '@/components/shared/buttons'
import { UpdatedAtLabel } from '@/components/shared/feedback/UpdatedAtLabel'
import { PageHeader } from '@/components/shared/navigation/PageHeader'
import { Chamados } from '@/features/chamados/components'
import { Asset_Displayer } from '@/features/patrimonios/views/components/Asset-Displayer'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { Repository } from '@/services/repository'

const Component = () => {
  const { client } = useAuthStore()

  const {
    data: calls,
    isFetching,
    dataUpdatedAt,
    refetch,
  } = useQuery(['dashboard-page-external', { client }], async () => {
    if (client)
      return await Repository.Entity.Call.Search({
        assetNumber: client.asset.assetNumber,
        contractId: client.contract.id,
      })
  })

  const { data: asset } = useQuery(
    ['dashboard-page-external-asset', { client }],
    async () => {
      if (client)
        return await Repository.Entity.Asset.FindById({ id: client.asset.id })
    },
  )

  return (
    <>
      <PageHeader title="Bem-vindo" />

      <Box p={8}>
        {asset && <Asset_Displayer data={asset} />}

        <Accordion allowMultiple defaultIndex={[0]} mt={8}>
          <AccordionItem>
            <h2>
              <AccordionButton>
                <Box as="span" flex="1" textAlign="left">
                  Chamados
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>

            <AccordionPanel>
              <Box mb={4}>
                <HStack w="fit-content">
                  <Dialog>
                    <DialogTrigger>
                      <Buttons.Add />
                    </DialogTrigger>
                    <Chamados.Core.Adicionar_Dialog_External
                      onSuccess={() => refetch()}
                    />
                  </Dialog>

                  <Buttons.Refresh
                    isLoading={isFetching}
                    onClick={() => refetch()}
                  />
                </HStack>

                <UpdatedAtLabel updatedAt={dataUpdatedAt} />
              </Box>

              {calls && (
                <Chamados.Core.Kanban_Card data={calls} isExternal={true} />
              )}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  )
}

export default Component
